module.exports = __webpack_public_path__ + "static/media/intumescent-coatings.f4dadc5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/optimised/intumescent-coatings.jpg
// module id = 88
// module chunks = 0